/* Leucadia override of Dawn's product-form custom element.
 * - Routes cart submission through LeucadiaCart to CHL
 * - Handle detection: URL first, then walk up from form to nearest card link
 * - T&C gate: refuses submit if a [data-leu-terms-agree] checkbox exists
 *   in the form's scope and is unchecked (checkbox on collection cards
 *   without T&C are treated as "no gate")
 * 2026-09-08: the cart line now records leuVariantId explicitly so
 *   leucadia-cart.js can re-resolve the Coast Highway variant at checkout
 *   against the current catalog (the key alone, 'leu-<id>', was the only
 *   place the variant lived before). */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class LeucadiaProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;
        var variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      toggleSubmitButton(disable, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      handleUpdateProductInfo() {}
      handleErrorMessage(errorMessage) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }
      getSectionsToRender() { return []; }
      getSectionInnerHTML() { return ''; }

      resolveHandle() {
        var pathMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
        if (pathMatch) return decodeURIComponent(pathMatch[1]);
        var scope = this.closest('.card-wrapper, .product__info-wrapper, .product-card-wrapper, .card, .grid__item, li, article, section');
        if (scope) {
          var link = scope.querySelector('a[href*="/products/"]');
          if (link) {
            var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
            if (m) return decodeURIComponent(m[1]);
          }
        }
        return null;
      }

      /* T&C gate. Returns true if allowed to proceed. */
      checkTermsAgreement() {
        /* Look in the form first, then the containing product-form / card scope. */
        var scope = this.form || this;
        var cb = scope.querySelector('[data-leu-terms-agree]');
        if (!cb) cb = this.querySelector('[data-leu-terms-agree]');
        if (!cb) {
          var section = this.closest('.card-wrapper, .product__info-wrapper, .product-card-wrapper, .grid__item, section, main');
          if (section) cb = section.querySelector('[data-leu-terms-agree]');
        }
        if (!cb) return true; /* No checkbox present — no gate (collection cards, quick-add, etc) */
        if (cb.checked) return true;
        /* Uncheked — flash the checkbox to draw attention */
        try {
          var label = cb.closest('.leu-terms') || cb.parentElement;
          if (label) {
            label.style.transition = 'transform 0.15s ease';
            label.style.transform = 'translateX(-4px)';
            setTimeout(function(){ label.style.transform = 'translateX(4px)'; }, 100);
            setTimeout(function(){ label.style.transform = ''; }, 200);
          }
        } catch (e) {}
        return false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        /* T&C gate BEFORE any state change so we don't lock the button. */
        if (!this.checkTermsAgreement()) {
          this.handleErrorMessage('Please agree to the Terms & Conditions to continue.');
          return;
        }

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        }
        var spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var handle = this.resolveHandle();

        var variantInputEl = this.form.querySelector('[name=id]');
        var leuVariantId = variantInputEl && variantInputEl.value ? String(variantInputEl.value) : null;

        var qtyInput = this.form.querySelector('[name=quantity]') || (this.closest('.card-wrapper, .product__info-wrapper, .grid__item') || document).querySelector('quantity-input [name=quantity], [name=quantity]');
        var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
        if (!qty || qty < 1) qty = 1;

        if (!window.LeucadiaCart || !window.LEUCADIA_CHL) {
          this.handleErrorMessage('Cart is loading. Please try again in a moment.');
          this.restoreButton();
          return;
        }

        var meta = null;
        if (window.LEUCADIA_CHL.resolve) {
          meta = window.LEUCADIA_CHL.resolve(leuVariantId, handle);
        } else if (window.LEUCADIA_CHL.lookup) {
          meta = window.LEUCADIA_CHL.lookup(handle);
        }
        if (!meta || !meta.variantId) {
          this.handleErrorMessage('This product is not available for online checkout. Please contact us.');
          this.restoreButton();
          return;
        }

        var imgScope = this.closest('.card-wrapper, .product__info-wrapper, .grid__item, .product-card-wrapper') || document;
        var imgEl = imgScope.querySelector('.product__media-item.is-active img, .product__media img, .product-media img, .product-single__media img, .product__modal-opener img, img');
        var image = imgEl && imgEl.src ? imgEl.src : '';

        var cartKey = leuVariantId ? ('leu-' + leuVariantId) : (handle || ('chl-' + meta.variantId));

        window.LeucadiaCart.add({
          key: cartKey,
          leuVariantId: leuVariantId || '',
          chlVariantId: meta.variantId,
          title: meta.title,
          price: meta.price,
          image: image || meta.image || '',
          qty: qty
        });
        window.LeucadiaCart.open();

        this.restoreButton('Added ✓');
      }

      restoreButton(text) {
        var btn = this.submitButton;
        if (!btn) return;
        var original = (this.submitButtonText && this.submitButtonText.textContent) || btn.textContent;
        btn.classList.remove('loading');
        var spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
        if (text && this.submitButtonText) {
          this.submitButtonText.textContent = text;
          setTimeout(function () {
            try {
              this.submitButtonText.textContent = original;
              btn.removeAttribute('aria-disabled');
            } catch (e) {}
          }.bind(this), 1200);
        } else {
          btn.removeAttribute('aria-disabled');
        }
      }
    }
  );
}